import React, {useEffect, useState} from 'react';

const Step = (props) => {
  const [active, setActive] = useState(props.activeTab);
  const [disabled, setDisabled] = useState(props.disabledTab);

  useEffect(() => {
    setActive(props.activeTab);
    setDisabled(props.disabledTab);
    let currContent = document.querySelector('.step__content.is-active');
    let thisContent = document.querySelector('.step__content[data-key="' + props.activeTab + '"]');
    currContent && currContent.classList.remove('is-active');
    thisContent && thisContent.classList.add('is-active');
  }, [props.activeTab, props.disabledTab]);

  
  const handleClick = (e) => {
    const elem = e.currentTarget,
      //tab = elem.closest(".step"),
      key = parseInt(elem.getAttribute('data-key'));
      //currContent = tab.querySelector('.step__content.is-active'),
      //thisContent = tab.querySelector('.step__content[data-key="' + key + '"]');

    //currContent && currContent.classList.remove('is-active');
    //thisContent && thisContent.classList.add('is-active');
    setActive(key);
    props.setActiveTab(key);
    renderTabs();
  }

  const renderTabs = () => {
    const titles = props.options.split('|'),
      html = [];
    let final = titles.length;

    titles.forEach((elem, i) => {
      let classNameResult = (active == i) ? ' active' : '';
      classNameResult = classNameResult + ((disabled == i) ? ' is-disabled' : '');
      //html.push(<div className={"step__option" + classNameResult} onClick={handleClick} key={i} data-key={i}>{elem}</div>)
      html.push(<div class={"market-steps__item " + classNameResult} onClick={(i<= props.paso)?handleClick:null} key={i} data-key={i}>
                  <div class={"market-steps__item__number " + ((final==(i+1))?"final":"")}>
                    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.23834 0.945607C7.4755 1.14628 7.50507 1.5012 7.30441 1.73835L3.17941 6.61335C3.07599 6.73557 2.92539 6.80793 2.76535 6.8123C2.60531 6.81667 2.45099 6.75263 2.34106 6.63624L0.216057 4.38624C0.00274996 4.16038 0.0129217 3.80437 0.238776 3.59107C0.46463 3.37776 0.82064 3.38793 1.03395 3.61379L2.72697 5.4064L6.4456 1.01167C6.64626 0.774516 7.00119 0.744939 7.23834 0.945607Z" fill="#ef3340">
                      </path>
                    </svg>
                    <span>{i+1}</span>
                  </div>
                  <div class="market-steps__item__text">
                  {elem}
                  </div>
                </div>);
    }); 
    return html;
  }
  
  return (     
    <div className={"step" + (props.className ? ' ' + props.className : '')}>
      <div className="step__wrapper">
        <div className="market-steps">               
          {renderTabs()}          
        </div>
      </div>
      
      <div className="step__contents">
        {props.contents}
      </div>
    </div>
  )
}

export default Step;